import React from "react";
import { Row, Col, Form, Input, Select } from "antd"; // Import Select from Ant Design
import classes from "../Pages.module.css";
import { useEffect, useContext, useState } from "react";

const { Option } = Select; // Destructure Option from Select

const FormRenderer = (props) => {
  console.log(props, "dfdff");
  const handleChange = (e, param) => {
    console.log(e.target.value);
    console.log(param);
    props.setData((data) => {
      const newdata = [...data["cityHeader"]];
      console.log(newdata);
      newdata[0][param] = e.target.value;
      return {
        ...data,
        cityHeader: newdata,
      };
    });
  };

  const handleSelectChange = (value, param) => {
    console.log(value);
    console.log(param);
    props.setData((data) => {
      const newdata = [...data["cityHeader"]];
      console.log(newdata);
      newdata[0][param] = value;
      return {
        ...data,
        cityHeader: newdata,
      };
    });
  };

  const handleAddRecord = () => {
    console.log(props.data);
  };

  return (
    <Row className={classes["RowDE"]}>
      <Col lg={5} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Site Name  <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Site Name"
              value={props.save ? props.data.site_desc : props.data.site_desc}
              onChange={(e) => handleChange(e, "site_desc")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>

      <Col lg={4} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold",
                }}
              >
                City <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Select
              placeholder="Select City"
              value={
                props.save ? props.data.city_code : props.data.city_code
              }
              onChange={(value) => handleSelectChange(value, "city_code")}
              style={{ width: "100%" }}
            >
              {props.ad.CITY_CODE.rows.map((option) => (
                <Option
                  style={{ textTransform: "capitalize", color: "#1777C4" }}
                  key={option[props.ad.CITY_CODE.fields[0].name]}
                  value={option[props.ad.CITY_CODE.fields[0].name]}
                >
                  {option[props.ad.CITY_CODE.fields[1].name]}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Col>

      <Col lg={4} md={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                State <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Select
              placeholder="Select State"
              value={props.save ? props.data.state_code : props.data.state_code}
              onChange={(value) => handleSelectChange(value, "state_code")}
              style={{ width: "100%" }}
            >
              {/* Add Options here */}
              {props.ad.STATE_CODE.rows.map((option) => (
                <Option
                  style={{ textTransform: "capitalize", color: "#1777C4" }}
                  key={option[props.ad.STATE_CODE.fields[0].name]}
                  value={option[props.ad.STATE_CODE.fields[0].name]}
                >
                  {option[props.ad.STATE_CODE.fields[1].name]}
                </Option>
              ))}
              {/* Add more options if needed */}
            </Select>
          </Form.Item>
        </Form>
      </Col>

      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Email <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Email"
              value={props.save ? props.data.email : props.data.email}
              onChange={(e) => handleChange(e, "email")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>

      <Col span={6} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Address <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Address"
              value={props.save ? props.data.add1 : props.data.add1}
              onChange={(e) => handleChange(e, "add1")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>

      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Service Tax No <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter service tax no"
              value={props.save ? props.data.service_tax_no : props.data.service_tax_no}
              onChange={(e) => handleChange(e, "service_tax_no")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Cin No <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Cin No"
              value={props.save ? props.data.cin_no : props.data.cin_no}
              onChange={(e) => handleChange(e, "cin_no")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Gst No <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Gst No"
              value={props.save ? props.data.gst_no : props.data.gst_no}
              onChange={(e) => handleChange(e, "gst_no")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Pan No <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Pan No"
              value={props.save ? props.data.pan_no : props.data.pan_no}
              onChange={(e) => handleChange(e, "pan_no")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Phone No <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Phone No"
              value={props.save ? props.data.ph1 : props.data.ph1}
              onChange={(e) => handleChange(e, "ph1")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Pin Code <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter pin_code"
              value={props.save ? props.data.pin_code : props.data.pin_code}
              onChange={(e) => handleChange(e, "pin_code")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Bank Name <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter bank Name"
              value={props.save ? props.data.bank_name : props.data.bank_name}
              onChange={(e) => handleChange(e, "bank_name")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


      <Col span={4} className={classes["Col"]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <div
                style={{
                  padding: "0rem 0.5rem",
                  fontSize: "0.7rem",
                  fontWeight: "bold", // Adding fontWeight bold
                }}
              >
                Ifsc Code <span style={{color:"red"}}>*</span>
              </div>
            }
            colon={false}
            style={{ margin: "0", padding: "0" }}
          >
            <Input
              placeholder="Enter Ifsc Code"
              value={props.save ? props.data.ifsc_cd : props.data.ifsc_cd}
              onChange={(e) => handleChange(e, "ifsc_cd")}
              bordered={true}
              style={{
                width: "100%",
                backgroundColor: "white",
                
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            />
          </Form.Item>
        </Form>
      </Col>


      <Col span={8} style={{ margin: "auto" }}>
        {props.save ? (
          <button
            onClick={(event) => props.handleSubmit(event)}
            className={classes["ProfileButtonF"]}
          >
            Add Record
          </button>
        ) : null}
      </Col>
    </Row>
  );
};

export default FormRenderer;
